import styled from 'styled-components';

const BetRecommendationsBetWrapper = styled.div`
	// Position and sizing
	max-width: 327px;
	min-width: 282px;
	min-height: 92px;
	height: 100%;
	border-radius: var(--base-radius-large);

	// Inside
	border: 1px solid var(--generic-stroke-10-percent);
	background-color: var(--main-surface-1);
	background-origin: border-box; // To ensure gradient is underneath border and allow transparent border
	position: relative;
	overflow: hidden;
	align-items: stretch;
	> * {
		flex: 1 0 100%;
	}
`;

export default BetRecommendationsBetWrapper;
